import React, { useState } from 'react';
import states from './state';
import city from './city';

const ButyNow = () => {
    const [Name, setName] = useState('')
    const [Email, setEmail] = useState('')
    const [Phone, setPhone] = useState('')
    const [Address, setAddress] = useState('')
    const [DOB, setDOB] = useState('')
    const [citys, setCitys] = useState('')
    const [Area, setArea] = useState('')
    const [state, setStates] = useState('')

    const customerData = [{ Name, Email, Phone, Address, DOB, citys, Area, state }]

    const proceedData = async (e) => {
        e.preventDefault();

        const res = await fetch('/cart/buy', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ Name, Email, Phone, Address, DOB, citys, Area, state })
        });
        const data = await res.json();
        console.log(data)

        if (res.status === 422 || !data) {
            alert('Invalid Registration')
        } else {
            console.log("Ragistration Succsessfull")
            alert("Ragistration Succsessfull")

        }


    }

    return (
        <div className='container-fluid'>
            <div className='row m-auto' style={{ width: '80%' }} >
                <div className='col-8' style={{
                    margin: 'auto', boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px', padding: '1rem'
                }}>
                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">Name </label>
                        <input
                            onChange={(e) => setName(e.target.value)}
                            required type="text"
                            value={customerData.name}
                            className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            name='name'
                        />

                    </div>

                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">Email </label>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            required type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            value={customerData.email}
                            name='email'
                        />

                    </div>

                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">Phone Number</label>
                        <input
                            onChange={(e) => setPhone(e.target.value)}
                            required type="text" className="form-control"
                            name='phone'
                            value={customerData.phone}
                            id="exampleInputEmail1" aria-describedby="emailHelp" />

                    </div>

                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">Address </label>
                        <div className="form-floating">
                            <textarea className="form-control"
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Write Address....."
                                name='address'
                                value={customerData.address}
                                id="floatingTextarea2" style={{ height: "100px" }}></textarea>

                        </div>

                    </div>

                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">DOB </label>
                        <input
                            onChange={(e) => setDOB(e.target.value)}
                            required type="date"
                            value={customerData.DOB}
                            name='DOB'
                            className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                    </div>


                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">City </label>
                        <select className="form-select"
                            name='cityss'
                            onChange={(e) => setCitys(e.target.value)}
                            aria-label="Default select example">
                            {
                                city.map((c) => {
                                    return <option value={c} >{c}</option>
                                })
                            }
                        </select>

                    </div>


                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">Area / Colony </label>
                        <input
                            onChange={(e) => setArea(e.target.value)}
                            required type="text" className="form-control"
                            name='area'
                            value={customerData.area}
                            id="exampleInputEmail1" aria-describedby="emailHelp" />

                    </div>


                    <div className=" col-12 mb-3">
                        <label for="exampleInputEmail1" className="form-label">State </label>
                        <select className="form-select"
                            name='states'
                            onChange={(e) => setStates(e.target.value)}
                            aria-label="Default select example">
                            {
                                states.map((s) => {
                                    return <option value={s} >{s}</option>
                                })
                            }
                        </select>

                    </div>

                    <div className="mb-3 form-check">
                        <input
                            required type="checkbox"
                            name='check'
                            value={customerData.check}
                            className="form-check-input" id="exampleCheck1" />
                        <label className="form-check-label" for="exampleCheck1">Accept term & condition</label>
                    </div>
                    <button required type="submit" className="btn btn-primary" onClick={proceedData}>
                        Procees To Pay
                    </button>
                </div>

            </div>
        </div>
    )
}
export default ButyNow;